import * as React from 'react';

import { Provider } from 'jotai';
import { WritableAtom } from 'jotai/vanilla';

import { HydrateAtoms } from '~shared/atoms/utils';

interface Props {
  initialValues: Iterable<
    readonly [WritableAtom<unknown, any[], any>, unknown]
  >;
  children: React.ReactNode;
}

export function TestProvider({ initialValues, children }: Props) {
  return (
    <Provider>
      <HydrateAtoms initialValues={initialValues}>{children}</HydrateAtoms>
    </Provider>
  );
}
